// Remove segredos que viajam na URL (hoje: o `token` do link de redefinição de senha) de eventos do Sentry.
// Módulo SEM imports para poder ser testado sem navegador (ver backend/tests/ocultar-segredos.test.ts).

const MARCADOR = '[Filtered]';

/** Troca o valor de `token=` em qualquer texto que contenha uma URL: na query (`?token=`/`&token=`), no
 *  fragmento (`#token=`) ou como `query_string` do Sentry, que vem sem o `?` (`"token=..."`). */
export const ocultarSegredosDaUrl = (texto: string): string =>
  texto.replace(/((?:^|[?&#"'\s])token=)[^&#"'\s\\]*/gi, `$1${MARCADOR}`);

/**
 * Aplica `ocultarSegredosDaUrl` em um objeto inteiro (evento, transação ou breadcrumb do Sentry):
 * `request.url`, `query_string`, `data.to/from`, `http.url` dos spans etc. vão todos na mesma passada.
 * Se o objeto não for serializável devolve o original (o Sentry já os serializa, então é raro).
 */
export function ocultarSegredosNoObjeto<T>(valor: T): T {
  try {
    return JSON.parse(ocultarSegredosDaUrl(JSON.stringify(valor))) as T;
  } catch {
    return valor;
  }
}

/** Páginas abertas por um link com segredo: nelas o Session Replay nem é ligado (ele grava a URL inicial). */
export const ehRotaComSegredoNaUrl = (pathname: string): boolean => /^\/redefinir-senha(\/|$)/.test(pathname);
